// extracted by mini-css-extract-plugin
export default {"root":"tag-module--root--bfcf8","icon":"tag-module--icon--406bf"};